import React, { useState } from 'react'
import { Main, MainBody, MainTop, MainTopTitle, WhiteBox, BoxHeader } from '@/components/Layout'
import Resx from '@/components/Resx'
import {
  actionButtonsColumnProps,
  BsrsGrid,
  DateFilterCell, DropDownFilterCell,
  EnumCellStatus,
  EnumFilterCell
} from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import context from '@/context'
import {
  customCellDateExport,
  customCellMultipleExport, customCellSimpleExport,
  DataCrossingsCustomCellMultiple,
  DataCrossingsCustomCellSimple,
  DataCrossingsCustomDateCell
} from './customCell'
import { TabContent, TabPane } from 'reactstrap'
import { TabNavItems } from '@/components/tabs'
import { useLocalization } from '@/hooks/localization'

function ProblematicCombinationsGrid (props) {
  const { persistenceId, dataSource, showStatus } = props
  const { localize, locale } = useLocalization()
  const enumName = 'ProblematicCombinationState'
  // Workaround to prevent passing null or undefined as child to BsrsGrid
  const columns = [
    <Column
      key={1}
      field='name'
      sortable={false}
      title={localize('DataCrossings.Name')}
      cell={(props) => <DataCrossingsCustomCellSimple fieldName='person' locale={locale} {...props} />}
      cellExport={customCellSimpleExport}
      cellExportProps={{ fieldName: 'person' }}
    />,
    <Column
      key={2}
      field='birthDate'
      title={localize('DataCrossings.BirthDate')}
      filter='date'
      sortable={false}
      cell={(props) => <DataCrossingsCustomDateCell fieldName='birthDate' {...props} />}
      filterCell={DateFilterCell}
      cellExport={customCellDateExport} />,
    <Column
      key={3}
      field='institution'
      title={localize('DataCrossings.Institution')}
      cell={(props) => <DataCrossingsCustomCellMultiple fieldName='institution' locale={locale} {...props} />}
      filterCell={DropDownFilterCell(context.api.institutionService.getLookup, { valueField: 'id', textField: 'name' })}
      sortable={false}
      cellExport={customCellMultipleExport}
    />,
    <Column
      key={4}
      field='jobPosition'
      title={localize('DataCrossings.JobPosition')}
      cell={(props) => <DataCrossingsCustomCellMultiple fieldName='relatedPersonType' locale={locale} {...props} />}
      sortable={false}
      cellExport={customCellMultipleExport}
      cellExportProps={{ fieldName: 'relatedPersonType' }}
    />,
    showStatus && <Column key={5} field='state' title={localize('Common.Status')} editable={false} width='120px'
      cell={EnumCellStatus({ localize, enumName, visualStatus: (val) => val === 1 ? 2 : 3 })}
      filterCell={EnumFilterCell({ localize, enumName }, [1, 2])} enumName={enumName} />,
    <Column key={6} {...actionButtonsColumnProps([
      {
        url: x => `/data-crossings-delinquents/${x.id}`,
        icon: 'show'
      }])} />].filter(x => x)
  return (
    <BsrsGrid persistenceId={persistenceId} dataSource={dataSource}>
      {columns}
    </BsrsGrid>
  )
}

export const DataCrossingProblematicCombinations = React.memo(function DataCrossingProblematicCombinations (props) {
  const [ activeTab, setActiveTab ] = useState('1')

  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='DataCrossings.DelinquentsTitle' />
        </MainTopTitle>
      </MainTop>
      <MainBody transparent>
        <WhiteBox>
          <TabNavItems activeTabId={activeTab} onClick={setActiveTab} items={[
            { id: '1', text: 'DataCrossings.NotChecked' },
            { id: '2', text: 'DataCrossings.Checked' }
          ]} />
          <TabContent activeTab={activeTab}>
            <TabPane tabId='1'>
              <BoxHeader className='header'><Resx name='DataCrossings.PossibleProblematicCombinations' /></BoxHeader>
              <ProblematicCombinationsGrid
                persistenceId={'data-crossing-possible-problematic-combinations'}
                dataSource={context.api.dataCrossingService.getPossibleProblematicCombinations} />
            </TabPane>
            <TabPane tabId='2'>
              <BoxHeader className='header'><Resx name='DataCrossings.SolvedProblematicCombinations' /></BoxHeader>
              <ProblematicCombinationsGrid
                persistenceId={'data-crossing-solved-problematic-combinations'}
                dataSource={context.api.dataCrossingService.getSolvedProblematicCombinations}
                showStatus />
            </TabPane>
          </TabContent>
        </WhiteBox>
      </MainBody>
    </Main>
  )
})



// WEBPACK FOOTER //
// ./src/internal-app/pages/dataCrossing/problematic-combinations.js